import { mapGetters } from "vuex";
export default {
  mounted() {
    this.updateBackgroundColor();
  },
  data() {
    return {
      backGroundColor: false
    };
  },
  computed: {
    ...mapGetters({
      landingIndex: "scroller/landingIndex",
      _color: "ui/sourceColor",
    })
  },
  methods: {
    updateBackgroundColor() {
      const c = this._color(this.landingIndex);

      this.backGroundColor = `var(--${c}-gradient)`;
    },
  },
  watch: {
    landingIndex() {
      this.updateBackgroundColor();
    },
  }
}